// src/config.js
import modelsData from './models.json';

// API Base URL - Your existing API Gateway URL
const PROMPT_ROUTER_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://0ic8rv7w2e.execute-api.us-east-1.amazonaws.com/prod'; //main
export const WEBSOCKET_API_URL = "wss://qt66uplqkf.execute-api.us-east-1.amazonaws.com/dev/"; //main
//const PROMPT_ROUTER_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://c0v8hcd556.execute-api.us-east-1.amazonaws.com/prod'; //erik
//export const WEBSOCKET_API_URL = "wss://45utyljlda.execute-api.us-east-1.amazonaws.com/dev-erik/"; //erik

// --- API Endpoints ---
export const INTAKE_API_URL = `${PROMPT_ROUTER_API_BASE_URL}/route`;
export const GETTER_API_URL = `${PROMPT_ROUTER_API_BASE_URL}/result`;
export const PRESIGNED_URL_API_URL = `${PROMPT_ROUTER_API_BASE_URL}/upload`;
export const FILE_PROCESSOR_API_URL = `${PROMPT_ROUTER_API_BASE_URL}/process-file`;
export const HISTORY_API_URL = `${PROMPT_ROUTER_API_BASE_URL}/conversations`;
export const SETTINGS_API_URL = `${PROMPT_ROUTER_API_BASE_URL}/settings`;

// AWS Cognito Configuration
export const REACT_APP_USER_POOL_ID=`us-east-1_nODWProxZ`; //main
export const REACT_APP_APP_CLIENT_ID=`6anq4n9fslh9a6nrkqf2shgkq9`; //main
//export const REACT_APP_USER_POOL_ID=`us-east-1_l6dQR0oIX`; //erik
//export const REACT_APP_APP_CLIENT_ID=`31v692fq5q6td5e8r27bng73qt`; //erik
export const REACT_APP_AWS_REGION=`us-east-1`;

// OAuth / Social Sign-In (required for Google login)
// Set these after configuring Google in the Cognito console.
// REACT_APP_COGNITO_DOMAIN: your Cognito hosted domain, e.g. "my-app.auth.us-east-1.amazoncognito.com"
// REACT_APP_REDIRECT_SIGN_IN / SIGN_OUT: must match the callback URLs registered in Cognito.
export const REACT_APP_COGNITO_DOMAIN = `us-east-1nodwproxz.auth.us-east-1.amazoncognito.com`; //main
//export const REACT_APP_COGNITO_DOMAIN = `us-east-1l6dqr0oix.auth.us-east-1.amazoncognito.com`; //erik
//export const REACT_APP_REDIRECT_SIGN_IN  = process.env.REACT_APP_REDIRECT_SIGN_IN  || 'http://localhost:3000'; //test environment "npm start"
//export const REACT_APP_REDIRECT_SIGN_OUT = process.env.REACT_APP_REDIRECT_SIGN_OUT || 'http://localhost:3000'; //test environment "npm start"
//export const REACT_APP_REDIRECT_SIGN_IN  = process.env.REACT_APP_REDIRECT_SIGN_IN  || 'https://erik.dd5j5dpcu5yc0.amplifyapp.com/'; //erik
//export const REACT_APP_REDIRECT_SIGN_OUT = process.env.REACT_APP_REDIRECT_SIGN_OUT || 'https://erik.dd5j5dpcu5yc0.amplifyapp.com/'; //erik
export const REACT_APP_REDIRECT_SIGN_IN  = process.env.REACT_APP_REDIRECT_SIGN_IN  || 'https://app.promptrouterai.com/'; //main
export const REACT_APP_REDIRECT_SIGN_OUT = process.env.REACT_APP_REDIRECT_SIGN_OUT || 'https://app.promptrouterai.com/'; //main

// --- Application Settings ---
export const POLLING_INTERVAL_MS = 3000;
export const MAX_POLLING_ATTEMPTS = 20;
export const DEMO_PROMPT_LIMIT = 3;

// File Upload Limits
// To change the limit: update REACT_APP_MAX_FILE_SIZE_MB in the env (no code change needed).
export const MAX_FILE_SIZE_MB = parseInt(process.env.REACT_APP_MAX_FILE_SIZE_MB || '5', 10);
export const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;
export const MAX_FILES_PER_MESSAGE = 5;
export const MAX_UPLOAD_PER_SESSION = 100 * 1024 * 1024; // 100MB
export const FILE_RETENTION_HOURS = 24;

// --- Model Definitions ---
// Derived at build time from backend/models/models.json via scripts/sync-models.js.
// Do NOT add models here manually — edit backend/models/models.json instead.
const _enabled = modelsData.models.filter(m => m.isEnabled !== false);

export const PROPRIETARY_MODELS = _enabled
    .filter(m => !m.isOpenSource)
    .map(m => m.displayName);

// Open-source models running on AWS Bedrock via IAM role.
// Credits ARE deducted for these models unless the user has an OpenRouter BYOK key.
export const OPEN_SOURCE_MODELS = _enabled
    .filter(m => m.isOpenSource)
    .map(m => m.displayName);

// Combined list of all models available in the UI
export const ALL_MODELS = _enabled.map(m => m.displayName);

// --- Provider groupings for the welcome model selector ---
// Groups are derived from the 'group' field in models.json.
// Order follows the first appearance of each group in the models list.
export const OTHER_GROUP_LABEL = 'Other';  // label for any unrecognised group

const _groupOrder = [];
const _groupMap = {};
for (const m of _enabled) {
    if (!_groupMap[m.group]) {
        _groupMap[m.group] = [];
        _groupOrder.push(m.group);
    }
    _groupMap[m.group].push(m.displayName);
}

export const PROVIDER_GROUPS = _groupOrder
    .filter(g => g !== OTHER_GROUP_LABEL)
    .map(g => ({ label: g, models: _groupMap[g] }));

// --- Per-model pricing (public rates, safe for frontend) ---
// displayName → { inputCostPer1MTokens, outputCostPer1MTokens }
// Use to display cost badges in model selectors.
export const MODEL_PRICING = Object.fromEntries(
    _enabled.map(m => [m.displayName, {
        input:  m.inputCostPer1MTokens  ?? 0,
        output: m.outputCostPer1MTokens ?? 0,
    }])
);

// --- Per-model pricing tier (derived from output cost) ---
// displayName → "Light" | "Standard" | "Premium"
// Light: output < $1/1M  |  Standard: $1–$9.99/1M  |  Premium: ≥ $10/1M
export const MODEL_TIER = Object.fromEntries(
    _enabled.map(m => {
        const out = m.outputCostPer1MTokens ?? 0;
        const tier = out < 1.0 ? 'Light' : out < 10.0 ? 'Standard' : 'Premium';
        return [m.displayName, tier];
    })
);